export const detailConstants = {
    DETAIL_SELECT: 'detail/select',
    DETAIL_CLEAR: 'detail/clear',
}